// 及时更新文档：
// https://confluence.zhihuiya.com/pages/viewpage.action?pageId=137986431
import { ColumnManageServiceSymbol } from '@/presentation/pages/detail/basic/service/ColumnManageService';
import { useFilterAside } from '@/presentation/pages/workspace-detail/composables/aside-panel/use-filter-aside';
import { FullscreenServiceSymbol } from '@/services/FullscreenService';
import FolderSort from '@/infrastructure/utils/folderSort';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import { UserService } from '@/domains/user/services/user-service.interface';
const detailService = injectService(DetailServiceSymbol);
const fullscreenService = injectService(FullscreenServiceSymbol);
const { isFilterAsideVisible, toggleFilterAside } = useFilterAside();
export default class FunctionBarServLock {
    constructor() {
        // 必须成为属性，因为需要vue2 reactive
        this.columnManageService = injectService(ColumnManageServiceSymbol);
        this.spaceService = injectService(SpaceService);
        this.folderService = injectService(FolderService);
        this.userService = injectService(UserService);
        this.fullscreenService = fullscreenService;
    }
    get spaceId() {
        return this.spaceService.spaceInfo.space_id;
    }
    get folderId() {
        return this.folderService.folderInfo.folder_id;
    }
    sortLocalSync(sortKey) {
        if (!sortKey) {
            return FolderSort.functionalRead(this.spaceId, this.folderId, detailService.detailType);
        }
        FolderSort.functionalWrite(this.spaceId, this.folderId, sortKey, detailService.detailType);
        return sortKey;
    }
    get columnManager_isDialogOpen() {
        return this.columnManageService.isDialogOpen;
    }
    columnManager_open(title) {
        return this.columnManageService.open(title);
    }
    get fullScreen_isActive() {
        return fullscreenService.active;
    }
    fullScreen_toggle() {
        return fullscreenService.toggle();
    }
    leftRefineTab_open() { }
    toImportData() {
        throw new Error('Not implemented');
    }
    toggleFilterAside() {
        toggleFilterAside();
    }
    getFilterAsideVisible() {
        return isFilterAsideVisible.value;
    }
    get customField_addIsAllowed() {
        const userPermission = this.userService.userPermission;
        const folderPermission = this.folderService.folderPermission;
        return userPermission.enable_custom_field &&
            folderPermission.enable_add_custom_field;
    }
    get customField_manageIsAllowed() {
        const userPermission = this.userService.userPermission;
        const spaceInfo = this.spaceService.spaceInfo;
        const spacePermission = this.spaceService.spacePermission;
        const isAdmin = this.userService.userInfo.admin_console;
        if (!userPermission.enable_custom_field || !spacePermission.enable_custom_field)
            return false;
        if (spaceInfo.is_shared_space)
            return false;
        if (spaceInfo.is_public_space && !isAdmin)
            return false;
        return true;
    }
    get fieldSetting_disabled() {
        return !!this.folderService.folderInfo?.async_display_field_with || false;
    }
}
